import { render } from "./Nasabah.vue?vue&type=template&id=2ebbc289&scoped=true"
import script from "./Nasabah.vue?vue&type=script&lang=js"
export * from "./Nasabah.vue?vue&type=script&lang=js"

import "./Nasabah.vue?vue&type=style&index=0&id=2ebbc289&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebbc289"]])

export default __exports__